import React from 'react';
import classNames from 'classnames';

const Header = ({ changeView, link, text, view }) =>  {

  const handleClick = (e, link) => {
    e.preventDefault();
    changeView(link, view)
  }

  const linkClass = classNames({
    'is-active': link === view || (link === 'questions' && view === 'results'),
  });

  return (
    <li>
        <a onClick={e => handleClick(e, link)} href="" className={linkClass}>{text}</a>
    </li>
  );
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/HeaderLink.js
 **/